import { render, staticRenderFns } from "./MyDivider.vue?vue&type=template&id=b13fac1a&scoped=true&"
import script from "./MyDivider.vue?vue&type=script&lang=js&"
export * from "./MyDivider.vue?vue&type=script&lang=js&"
import style0 from "./MyDivider.vue?vue&type=style&index=0&id=b13fac1a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b13fac1a",
  null
  
)

export default component.exports